import React from "react";
import { useNavigate } from "react-router-dom";
import { IntakeComposer } from "@/components/intake/IntakeComposer";
import { stashIntake } from "@/lib/intakeHandoff";

/** The composer on Hjem: whatever you drop or write here opens the conversation on /ny with it. */
export function StartComposer({ placeholder, className, variant = "hero" }) {
  const navigate = useNavigate();
  const go = (payload) => { stashIntake(payload); navigate("/ny"); };
  return <IntakeComposer className={className} variant={variant} placeholder={placeholder} onSend={(text) => go({ text })} onFiles={(files) => go({ files })} />;
}
